import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LottieModule } from 'ngx-lottie';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';
import { PageActionsMenuComponent } from './page-actions-menu/page-actions-menu.component';
import { LoaderComponent } from './loader/loader.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { DataTableComponent } from './data-table/data-table.component';

@NgModule({
  declarations: [
    BreadcrumbComponent,
    EmptyStateComponent,
    PageActionsMenuComponent,
    LoaderComponent,
    NotFoundComponent,
    DataTableComponent,
  ],
  imports: [CommonModule, RouterModule, MatButtonModule, MatMenuModule, MatProgressSpinnerModule, LottieModule],
  exports: [
    BreadcrumbComponent,
    EmptyStateComponent,
    PageActionsMenuComponent,
    LoaderComponent,
    NotFoundComponent,
    DataTableComponent,
  ],
})
export class ComponentsModule {}
